import { createContext, useContext } from 'react';
import { hitlApi, type HitlApi } from '../../services/hitl';

export const HitlApiContext = createContext<HitlApi>(hitlApi);
export const useHitlApi = () => useContext(HitlApiContext);
